import React from 'react'
import { string, shape, node } from 'prop-types'
import BoxSimpleHeader from './BoxSimpleHeader'
import ThemeConsumer from '../ThemeConsumer'


const BoxHeader = ({
  theme,
  title,
  children,
}) => (
  <BoxSimpleHeader>
    <div>
      <h3 className={theme.title}>{title}</h3>
      {typeof children.slice === 'function' && children.slice(0, -1)}
    </div>

    {typeof children.slice === 'function' && children.slice(-1)}
  </BoxSimpleHeader>
)

BoxHeader.propTypes = {
  children: node,
  title: string.isRequired,

  theme: shape({
  }),
}

BoxHeader.defaultProps = {
  children: null,
  theme: {},
}

export default ThemeConsumer('UIBox')(BoxHeader)



// WEBPACK FOOTER //
// ./src/shared/components/Box/BoxHeader.js